import { render, staticRenderFns } from "./I18n.vue?vue&type=template&id=1caa2110&scoped=true"
import script from "./I18n.vue?vue&type=script&lang=js"
export * from "./I18n.vue?vue&type=script&lang=js"
import style0 from "./I18n.vue?vue&type=style&index=0&id=1caa2110&prod&scoped=true&lang=css"
import style1 from "./I18n.vue?vue&type=style&index=1&id=1caa2110&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caa2110",
  null
  
)

export default component.exports